import { CannyioEmbed } from '../../UI/CannyioEmbed'

export const RequestFeature = () => {
    return <CannyioEmbed />
}
